import Filter from "../Filter/Filter";
import React from "react";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import RoverForm from "../RoverForm/RoverForm";
import '../Filter/Filter.scss';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import DualRange from "../DualRange";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL, isAgentUser, groupObjectByIndex } from "../../utils";
import SelectMultiTenantFilter from "../SelectMultiTenantFilter";

export default class RoverListFilter extends Filter {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      query,
      paneIndex,
      buyerStateBreakdownCheckbox,
      transactionBreakdownCheckbox,
      marketTransactionBreakdownCheckbox,
      marketShareCheckbox
    } = this.state;

    const isTransactionBreakdown =
      transactionBreakdownCheckbox ||
      marketTransactionBreakdownCheckbox ||
      marketShareCheckbox;

    const isFinancing = query && query.source === "HSC";

    const panes = [
      (
        <div className="RoverFilter_wrapper">
          <h3>Property Info</h3>

          <Input theme="dark" valueType="text" name="name" label="Property Name"
            value={query.name} disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />

          <Input theme="dark" valueType="text" name="address" label="Address"
            value={query.address} disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />

          <Input theme="dark" valueType="text" name="city" label="City"
            value={query.city} disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />

          <Dropdown dropdownType="multiple" theme="dark" optionsType="states"
            optionKey="abbr" optionLabelKey="name"
            value={query.state} valueKey="state" label="State"
            data={query} disabled={isTransactionBreakdown} isFilter
            handleParentChange={this.handleDropdownChange} />

          <Input theme="dark" valueType="text" name="zip" label="Zip"
            value={query.zip} disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />

          <Dropdown dropdownType="multiple" theme="dark" optionsType="market"
            optionKey="code" optionLabelKey="name"
            value={query.market} valueKey="market" label="Market"
            data={query} disabled={isTransactionBreakdown} isFilter
            handleParentChange={this.handleDropdownChange} />

          {isFinancing ? (
            <Dropdown dropdownType="multiple" theme="dark" optionsType="status-financing"
              value={query.hsc_status} valueKey="hsc_status" label="Status"
              data={query} disabled={isTransactionBreakdown} isFilter
              handleParentChange={this.handleDropdownChange} />
          ) : (
            <Dropdown dropdownType="multiple" theme="dark" optionsType="status"
              optionKey="code" value={query.status} valueKey="status" label="Status"
              data={query} disabled={isTransactionBreakdown} isFilter
              handleParentChange={this.handleDropdownChange} />
          )}

          <Dropdown theme="dark" optionsType="source"
            value={query.source} valueKey="source" label="Source"
            data={query} disabled={isTransactionBreakdown} isFilter
            handleParentChange={this.handleDropdownChange}
            optionKey="code" optionLabelKey="name" />

          <Dropdown theme="dark" optionsType="transaction"
            value={query.transaction_type} valueKey="transaction_type" label="Transaction Type"
            data={query} disabled={isTransactionBreakdown} isFilter
            handleParentChange={this.handleDropdownChange} />

          <Dropdown dropdownType="multiple" theme="dark" optionsType="category"
            optionKey="code" optionLabelKey="name"
            value={query.category} valueKey="category" label="Category"
            data={query} disabled={isTransactionBreakdown} isFilter
            handleParentChange={this.handleDropdownChange} />

          {query.category === "apartments" && (
            <Dropdown theme="dark" optionKey="code" optionLabelKey="name"
              data={query} isFromProperty optionsType="subcategory"
              value={query.sub_category} valueKey="sub_category" label="Sub Category"
              disabled={isTransactionBreakdown} handleParentChange={this.handleDropdownChange} />
          )}

          {query.category !== "apartments" && (
            <Dropdown theme="dark" optionsType="type"
              optionKey="code" optionLabelKey="name"
              value={query.type} valueKey="type" label="Type"
              data={query} disabled={isTransactionBreakdown} isFilter
              handleParentChange={this.handleDropdownChange} />
          )}

          {query.type === "STNL" && (
            <div>
              {getTenantSubcategorySTNL({ data: query, handleChangeDropdown: this.handleDropdownChange, theme: "dark", disabled: isTransactionBreakdown, isFilter: true })}
              <Dropdown theme="dark" optionsType="lease"
                value={query.lease_type} valueKey="lease_type" label="Lease Type"
                data={query} disabled={isTransactionBreakdown} isFilter
                handleParentChange={this.handleDropdownChange} />
            </div>
          )}

          {query.type === "MT" &&
            getTenantSubcategoryMT({ data: query, handleChangeDropdown: this.handleDropdownChange, theme: "dark", disabled: isTransactionBreakdown, isFilter: true })}

          {query.type === "MT" && (
            <SelectMultiTenantFilter theme="dark" optionsType="tenant"
              value={query.tenant_id} valueKey="tenant_id" label="Tenant"
              data={query} disabled={isTransactionBreakdown} isFilter
              handleParentChange={this.handleDropdownChange} />
          )}

          {query.category === "apartments" && (
            <DualRange theme="dark" minValue={query.units_min} maxValue={query.units_max}
              minName="units_min" maxName="units_max" valueType="integer" label="# of Units"
              disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />
          )}

          {query.category !== "apartments" && (
            <DualRange theme="dark" minValue={query.sqft_min} maxValue={query.sqft_max}
              minName="sqft_min" maxName="sqft_max" valueType="integer" label="Square Feet"
              disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />
          )}

          <DualRange theme="dark" minValue={query.lot_size_min} maxValue={query.lot_size_max}
            minName="lot_size_min" maxName="lot_size_max" valueType="integer" label="Lot Size"
            disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />

          <DualRange theme="dark" minValue={query.year_built_min} maxValue={query.year_built_max}
            minName="year_built_min" maxName="year_built_max" valueType="number" label="Year Built"
            disabled={isTransactionBreakdown} handleParentChange={this.handleChange} />
        </div>
      )
    ];

    return (
      <div className="StriveVisionWrapper">
        {/* Map behind */}
        <div className="MapContainer">
          {React.cloneElement(this.props.children, { isSuper: this.props.isSuper ,isClearRoverFilter:this.state.isClearFilter})}
        </div>

        {/* Filter panel overlay */}
        <div className="RoverFilter">
          <SearchPanel ref="searchPanel">
            <form onSubmit={this.handleSubmit}>
              <nav className="RoverFilter_nav">
                <span className="RoverFilter_textButton"
                      onClick={this.close}
                      style={{ cursor: "pointer", color: "white", marginLeft: "500px" }}>
                  <b>Close</b>
                </span>
              </nav>

              <div className="RoverFilter_slider">
                {panes.map((el, key) => (
                  <Control key={key} onClick={() => this.handlePaneChange(key)}>
                    <div className={
                      "RoverFilter_slider_icon" +
                      (key === this.state.paneIndex ? " RoverFilter_slider_icon--active" : "")
                    }/>
                  </Control>
                ))}
              </div>

              {/* Active pane */}
              {panes[this.state.paneIndex]}

              {/* Apply / Clear */}
              <div className="RoverFilter_buttons">
                <button type="button" className="button-new negative dark" onClick={this.clear}>Clear</button>
                <button className="button-new positive">Apply</button>
              </div>
            </form>
          </SearchPanel>
        </div>
      </div>
    );
  }
}



